import { useContext, useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { EventAgendaSchedule } from 'src/modules/events/models';
import { EventPageSignupPopup } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageSignupPopup';
import { EventPageAgendaScheduleDay } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaScheduleDay';
import { useEventTicketQuery } from 'src/modules/events/hooks/useEventTicketQuery';
import { EventPageContext } from 'src/modules/events/components/EventPage/EventPageContext';

export interface EventPageAgendaScheduleProps {
  schedule: EventAgendaSchedule;
}

export const EventPageAgendaSchedule = ({
  schedule,
}: EventPageAgendaScheduleProps) => {
  const [expandedTimeslots, setExpandedTimeslots] = useState<string[]>([]);
  const [selectedTimeslots, setSelectedTimeslots] = useState<string[]>([]);
  const popupVisible = selectedTimeslots.length > 0;

  const { event } = useContext(EventPageContext);
  const { data: tickets } = useEventTicketQuery(event.id);

  useEffect(() => {
    /*
      Remove selected timeslots that are already present in ticket. This is possible in scenario when user
      selects timeslots as guest and later logs in and has already signed up for some of them previously.
     */
    setSelectedTimeslots((current) =>
      current.filter((a) => !tickets?.timeslots.includes(a)),
    );
  }, [tickets]);

  return (
    <>
      <AnimatePresence initial={false}>
        {popupVisible ? (
          <EventPageSignupPopup
            timeslotIds={selectedTimeslots}
            onComplete={() => setSelectedTimeslots([])}
          ></EventPageSignupPopup>
        ) : null}
      </AnimatePresence>
      <AnimatePresence initial={false}>
        {schedule.map((scheduleDay, i) => (
          <EventPageAgendaScheduleDay
            key={scheduleDay.longLabel}
            scheduleDay={scheduleDay}
            day={i + 1}
            expandedTimeslots={expandedTimeslots}
            setExpandedTimeslots={setExpandedTimeslots}
            selectedTimeslots={selectedTimeslots}
            setSelectedTimeslots={setSelectedTimeslots}
          ></EventPageAgendaScheduleDay>
        ))}
      </AnimatePresence>
    </>
  );
};
